@if (!isCompoundFieldMember && showLabel) {
<label
  [attr.for]="id"
  soho-label
    [required]="required$ | async"
  lm-label
    [layoutField] = "field"
    [layoutInfo]="layoutInfo"
    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [personalize]="personalize && !field?.label?.textStyle.color"
  lm-text-style
    [textStyle]="field?.label?.textStyle"
  (blur)="onBlur($event)"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>
}

@switch (formType) {
  @case (formDisplayType.SEARCH_FORM) {
    @if (isCompoundFieldMember) {
      <!-- On a search form and in the preview mode (occurs in the lm-compact-dialog modal) -->
      @if (lmParagraphLayoutInfo.previewMode) {
        <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayPreviewMode"></ng-container>
      } @else {
        <ng-container *ngTemplateOutlet="NormalMode"></ng-container>
      }
      <!-- On a search form, just a compound field member NOT in the preview -->
      <ng-template #NormalMode>
        <div>
          @switch (displayType) {
            @case (layoutDisplayType.PLAIN) {
              <input
                [attr.id]="id"
                [attr.bindId]="bindId"
                [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
                [attr.maxlength]="maxLength"
                [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                (ngModelChange)="onNgModelChange($event)"
                #Input
                  [ngClass]="fieldClassesString"
                  [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                soho-lookup
                  icon="{{iconDisplay}}"
                  [click]="onLookupClick"
                  [field]="onLookupField"
                  [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
                lm-displayupper
                  [isUpperCase]="isUpperCase"
                lm-field-style
                  [specField]="specField"
                  [recalculateStyles]="triggerValueChange | async"
                soho-busyindicator
                  blockUI="true"
                  displayDelay="0"
                soho-alert
                (focus)="onFocus($event)"
                (blur)="onBlur($event)"
              />
            }
            @case (layoutDisplayType.MASK) {
              <input
                #Input
                [ngClass]="fieldClassesString"
                [ngStyle]="{'display': showField ? 'inline-block' : 'none'}"
                [attr.id]="id"
                [attr.bindId]="bindId"
                [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
                [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                (ngModelChange)="onNgModelChange($event)"
                soho-lookup
                  icon="{{iconDisplay}}"
                  [click]="onLookupClick"
                  [field]="onLookupField"
                  [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
                lm-field-style
                  [specField]="specField"
                  [recalculateStyles]="triggerValueChange | async"
                soho-mask
                  [options]="maskOptions"
                soho-busyindicator
                  blockUI="true"
                  displayDelay="0"
                 soho-alert
                (focus)="onFocus($event)"
                (blur)="onBlur($event)"
              />
            }
          }
          <!-- Handle displaying the label or value as text when not showField (the field isn't focused)-->
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayNormalMode"></ng-container>
        </div>
      </ng-template>
    } @else {
      @switch (displayType) {
        @case (layoutDisplayType.PLAIN) {
          <input
            #Input
            [ngClass]="fieldClassesString"
            [attr.id]="id"
            [attr.bindId]="bindId"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            [readonly]="(readOnly$ | async) ? true : null"
            soho-lookup
              icon="{{iconDisplay}}"
              [click]="onLookupClick"
              [field]="onLookupField"
              [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async))"
              [attr.aria-describedby]="fieldDescriptionId"
            lm-displayupper
              [isUpperCase]="isUpperCase"
            lm-field-style
              [specField]="specField"
              [recalculateStyles]="triggerValueChange | async"
            soho-alert
            soho-busyindicator
              blockUI="true"
              displayDelay="0"
            soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
            soho-field-filter
              [fieldDropdownDataSet]="filterSettings"
              [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField :'contains'"
              (filtered)="onFiltered($event)"
              (blur)="onBlur($event)"
          />
        }
        @case (layoutDisplayType.MASK) {
          @if (transformOptions.allowMultiSelections) {
            <input
                   #Input
                   [ngClass]="fieldClassesString"
                   [attr.id]="id"
                   [attr.bindId]="bindId"
                   [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                   (ngModelChange)="onNgModelChange($event)"
                   soho-lookup
                   icon="{{iconDisplay}}"
                   [click]="onLookupClick"
                   [field]="onLookupField"
                   [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async))"
                   [attr.aria-describedby]="fieldDescriptionId"
                   lm-field-style
                   [specField]="specField"
                   [recalculateStyles]="triggerValueChange | async"
                   soho-alert
                   soho-mask
                   [options]="searchFieldMaskOptions"
                   soho-busyindicator
                   blockUI="true"
                   displayDelay="0"
                   soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                   soho-field-filter
                   [fieldDropdownDataSet]="filterSettings"
                   [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
                   (filtered)="onFiltered($event)"
                   (blur)="onBlur($event)"
            />
          } @else {
            <input
                   #Input
                   [ngClass]="fieldClassesString"
                   [attr.id]="id"
                   [attr.bindId]="bindId"
                   [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
                   (ngModelChange)="onNgModelChange($event)"
                   [readonly]="(readOnly$ | async) ? true : null"
                   soho-lookup
                   icon="{{iconDisplay}}"
                   [click]="onLookupClick"
                   [field]="onLookupField"
                   [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async))"
                   [attr.aria-describedby]="fieldDescriptionId"
                   lm-field-style
                   [specField]="specField"
                   [recalculateStyles]="triggerValueChange | async"
                   soho-alert
                   soho-mask
                   [options]="maskOptions"
                   soho-busyindicator
                   blockUI="true"
                   displayDelay="0"
                   soho-tooltip content="{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions}}"
                   soho-field-filter
                   [fieldDropdownDataSet]="filterSettings"
                   [selectedFilterType]="triggerValueChange | async | toFieldOperator : modelField"
                   (filtered)="onFiltered($event)"
                   (blur)="onBlur($event)"
            />
          }
        }
      }
      @if (showBarCodeScanOptions) {
        <lm-scan-options
          [isMemberField]="isCompoundFieldMember"
          [dataEntryMode]="dataEntryMode"
          [hasContextMenu]="true"
          [displayScanOptions]="true"
          [ajaxCallbackFunction]="onBeforeScanContextMenuOpen"
          [contextMenuEventFunction]="contextMenuClicked"
          [buttonId]="scanOptionsId"
          [isInAccessibilityMode]="isInAccessibilityMode"
        ></lm-scan-options>
      }
        @if (layoutInfo.isAdHoc) {
          <button
            id="AdHocRemove"
            class="lm-compound-field-dialog-button lm-adhoc-remove"
            soho-button="icon"
            [icon]="'close-small'"
            soho-tooltip
            [content]="'Remove Field'"
            (click)="removeAdHocField($event)"
          ></button>
        }
    }
  }
  @default {
    <!-- Not on a search form -->
    <div
      [ngClass]="{'disabled-member-field': disabledMemberField, 'lm-is-display-as-tag': displayAsTag, 'lm-is-display-as-text': displayAsText }"
      lm-field-options
        [isMemberField]="isCompoundFieldMember"
        [dataEntryMode]="dataEntryMode"
        [hasContextMenu]="insertContextMenu"
        [ajaxCallbackFunction]="onBeforeContextMenuOpen"
        [contextMenuEventFunction]="contextMenuClicked"
        [buttonId]="fieldOptionsId"
        [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
        [isInAccessibilityMode]="isInAccessibilityMode"
        [displayFieldOptions]="displayFieldOptions"
        [disableFieldOptions]="disableFieldOptions"
        [fieldAutomationId]="fieldAutomationId"
      lm-layout-util
        [hideWhiteSpace]="shouldHideWhiteSpace"
      soho-tooltip
        [popover]="true"
        [title]="popoverTitle"
        [placement]="'right'"
        [trigger]="'click'"
      (focus)="onFocus($event)"
      (focusin)="onFieldFocus($event)"
      (focusout)="onFieldBlur($event)"
      (contextmenu)="onContextMenu($event)">
      @switch (displayType) {
        @case (layoutDisplayType.PLAIN) {
          <input
            #Input
            [ngClass]="fieldClassesString"
            [attr.id]="id"
            [id]="id"
            [attr.bindId]="bindId"
            [attr.maxlength]="maxLength"
            [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : null"
            [readonly]="(readOnly$ | async) ? true : null"
            [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
            [attr.aria-describedby]="fieldDescriptionId"
            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            soho-lookup
              icon="{{iconDisplay}}"
              [click]="onLookupClick"
              [field]="onLookupField"
              [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
            lm-displayupper
              [isUpperCase]="isUpperCase"
            lm-field-style
              [specField]="specField"
              [recalculateStyles]="triggerValueChange | async"
            soho-alert
            soho-trackdirty
              [searchForm]="onSearchForm"
              (dirty)="onDirty($event)"
              (pristine)="onPristine($event)"
              (afterResetDirty)="onAfterResetDirty($event)"
            soho-input-validate
              (error)="onError($event)"
              (valid)="onValid($event)"
            soho-busyindicator
              blockUI="true"
              displayDelay="0"
            (blur)="onBlur($event)"
            (input)="onInput($event)"
          />
        }
        @case (layoutDisplayType.MASK) {
          <input
            #Input
            [ngClass]="fieldClassesString"
            [attr.id]="id"
            [id]="id"
            [attr.bindId]="bindId"
            [attr.aria-label]="(isCompoundFieldMember) ? (triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields) : null"
            [readonly]="(readOnly$ | async) ? true : null"
            [attr.tabindex]="isPreviewCompoundMember || !isInAccessibilityMode && (readOnly$ | async) ? -1 : null"
            [attr.aria-describedby]="fieldDescriptionId"
            [ngModel]="modelField.valueChanged | async | toDisplayValue:specField:transformOptions"
            (ngModelChange)="onNgModelChange($event)"
            soho-lookup
              icon="{{iconDisplay}}"
              [click]="onLookupClick"
              [field]="onLookupField"
              [tabbable]="!(!isInAccessibilityMode || (readOnly$ | async) || isCompoundFieldMember)"
            lm-field-style
              [specField]="specField"
              [recalculateStyles]="triggerValueChange | async"
            soho-mask
              [options]="maskOptions"
            soho-alert
            soho-trackdirty
              [searchForm]="onSearchForm"
              (dirty)="onDirty($event)"
              (pristine)="onPristine($event)"
              (afterResetDirty)="onAfterResetDirty($event)"
            soho-input-validate
              (error)="onError($event)"
              (valid)="onValid($event)"
            soho-busyindicator
              blockUI="true"
              displayDelay="0"
            (blur)="onBlur($event)"
            (input)="onInput($event)"
          />
        }

        <!-- display as tag -->
        @case (layoutDisplayType.TAG) {
          <div
              class="tag-container"
              soho-alert
              lm-field-style
                  [fieldStyle]="layoutObject?.fieldStyle"
                  [specField]="specField"
                  [recalculateStyles]="triggerValueChange | async"

          >
              <span class="tag is-dismissible"
                  [attr.id]="id"
                  [attr.tabindex]="isInAccessibilityMode ? 0 : null"
                  [class.data]="true"
                  [ngClass]="{'is-active': isFieldTagFocused, 'is-focused': isFieldTagFocused, 'hide-focus': !isFieldTagFocused}"
                  [ngStyle]="{'display': 'inline-block', 'color': '#FFFFFF', 'outline': 'none'}"
                  soho-alert
                  lm-field-style
                      [fieldStyle]="tagStyle?.style"
                      [specField]="specField"
                      [isTag]="true"
                      [recalculateStyles]="triggerValueChange | async"
                  (focus)="onTagFocus()"
                  (blur)="onTagBlur()"
              >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</span>
          </div>
        }

        <!-- display as text -->
        @case (layoutDisplayType.TEXT) {
          <p
              attr.id="{{id}}"
              class="lm-text-data hide-white-space"
              [class.personalize-text]="personalize && !layoutObject?.fieldStyle?.color"
              [ngStyle]="{'display': 'inline-block'}"
              [class.data]="true"
              soho-alert
              lm-field-style
                [fieldStyle]="layoutObject?.fieldStyle"
                [specField]="specField"
                [recalculateStyles]="triggerValueChange | async"
          >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
        }
      }

      @if (showCompactDialogButton) {
        <button
          soho-button="btn-icon"
          icon="launch"
          id="CompactForm"
          class="lm-compound-field-dialog-button"
          (click)="openCompactDialog($event)"
          soho-tooltip
          [content]="launchButtonTooltip"
        >
          <span class="audible">{{launchButtonTooltip}}</span>
        </button>
      }

      @if (showBarCodeScanOptions) {
        <lm-scan-options
            [isMemberField]="isCompoundFieldMember"
            [dataEntryMode]="dataEntryMode"
            [hasContextMenu]="true"
            [displayScanOptions]="true"
            [ajaxCallbackFunction]="onBeforeScanContextMenuOpen"
            [contextMenuEventFunction]="contextMenuClicked"
            [buttonId]="scanOptionsId"
            [isInAccessibilityMode]="isInAccessibilityMode"
        ></lm-scan-options>
      }

      <!-- Handle the compound field member display label/value not focused in compact format on a form -->
      @if (isCompoundFieldMember) {
        @if (lmParagraphLayoutInfo?.previewMode) {
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayPreviewMode"></ng-container>
        } @else {
          <ng-container *ngTemplateOutlet="CompoundPlaceHolderDisplayNormalMode"></ng-container>
        }
      }
    </div>
  }
}

<ng-template #CompoundPlaceHolderDisplayNormalMode>
    @if (isDirty) {
      <span class="icon-dirty lm-compound-member-field-dirty"></span>
    }
    @if (!(modelField.valueChanged | async | isBlankValue:specField)) {
        <p
            attr.id="{{id}}-text"
            class="lm-compound-text hide-white-space"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
            (focus)="onFocus($event)"
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
    } @else {
        <p
            attr.id="{{id}}-text"
            [attr.tabindex]="(!disabledMemberField) ? tabIndexForFieldOptions : null"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !(readOnly$ | async)}"
            [ngStyle]="{'display': showField ? 'none' : 'inline-block'}"
            soho-tooltip
            [content]="showLabel ? '' : triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields"
            soho-alert
            (focus)="onFocus($event)"
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
    }
</ng-template>

<ng-template #CompoundPlaceHolderDisplayPreviewMode>
    @if (!(isCompoundFieldMember && (modelField.valueChanged | async | isBlankValue:specField))) {
        <p
            attr.id="{{id}}-text"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            class="lm-compound-text hide-white-space"
            [ngStyle]="{'display': 'inline-block'}"
            soho-alert
        >{{modelField.valueChanged | async | toDisplayValue:specField:transformOptions | formatMessageRule:true:field.text:model:specFields}}</p>
    } @else {
        <p
            attr.id="{{id}}-text"
            [attr.aria-label]="triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields"
            [ngClass]="{'lm-compound-text preview-placeholder': true, 'input-style is-placeholder': !(readOnly$ | async)}"
            [ngStyle]="{'display': 'inline-block'}"
            soho-alert
        >{{triggerValueChange | async | formatMessageRule:false:labelResourceValue:model:specFields}}</p>
    }
</ng-template>

<div #dialogPlaceholder id="lmLookupDialogPlaceholder" class="lmDialogPlaceholder"></div>
<!-- <div #dialogPlaceholder id="lmLookupDialogPlaceholder" [ngClass]="{'modal': isModal}"></div> -->

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>
@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}